import { Alert, AlertContent, AlertTitle } from "#ui/alert";

export function CheckImageUnavailable() {
  return (
    <Alert intent="warning">
      <AlertContent>
        <AlertTitle>
          Check image is not available for this deposit. If you need assistance,
          please contact your Advisor Team.
        </AlertTitle>
      </AlertContent>
    </Alert>
  );
}
